var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDriveOutlinedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3540_264748)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3540_264748",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.394531 1.90735e-06H32.3946V32H0.394531V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3540_264748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.44768 22.3495C3.60578 22.6718 3.47268 23.0612 3.15039 23.2193C2.82809 23.3774 2.43865 23.2443 2.28055 22.922L3.44768 22.3495ZM8.38006 3.26781L8.72596 3.81812L8.72596 3.81813L8.38006 3.26781ZM2.28055 22.922C-1.21526 15.7958 1.1644 7.03541 8.03416 2.71748L8.72596 3.81813C2.42532 7.77833 0.241729 15.8142 3.44768 22.3495L2.28055 22.922ZM8.03416 2.71749C12.9558 -0.375984 18.9327 -0.40325 23.7285 2.1223L23.1228 3.27256C18.7205 0.954233 13.239 0.98147 8.72596 3.81812L8.03416 2.71749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9389 8.92847C28.762 8.61608 28.8719 8.21946 29.1842 8.04258C29.4966 7.8657 29.8933 7.97556 30.0701 8.28794L28.9389 8.92847ZM24.4074 28.7697L24.0615 28.2194L24.0615 28.2194L24.4074 28.7697ZM30.0701 8.28794C34.182 15.55 31.8914 24.8334 24.7533 29.32L24.0615 28.2194C30.6086 24.1042 32.71 15.5888 28.9389 8.92847L30.0701 8.28794ZM24.7533 29.32C19.6172 32.5483 13.3387 32.4317 8.44844 29.5629L9.10624 28.4416C13.595 31.0749 19.3526 31.1791 24.0615 28.2194L24.7533 29.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1959 4.03491C28.1959 5.48478 27.0205 6.66016 25.5706 6.66016C24.1208 6.66016 22.9453 5.48478 22.9453 4.03491C22.9453 2.58503 24.1208 1.40966 25.5706 1.40966C27.0205 1.40966 28.1959 2.58503 28.1959 4.03491Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1841 27.4377C9.1841 28.8876 8.00873 30.063 6.55885 30.063C5.10897 30.063 3.93359 28.8876 3.93359 27.4377C3.93359 25.9879 5.10897 24.8125 6.55885 24.8125C8.00873 24.8125 9.1841 25.9879 9.1841 27.4377Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4501 20.7822C24.109 20.7822 25.4523 19.4314 25.44 17.7697C25.4278 16.1211 24.0613 14.8024 22.4126 14.8024H21.7543C21.7543 13.3785 20.6 12.2241 19.1761 12.2241L18.8559 12.2272C18.8559 10.3024 17.2611 8.71723 15.3363 8.71723C13.3731 8.71723 11.7817 10.3087 11.7817 12.2719V12.7088H11.3804C9.15107 12.7088 7.34375 14.5161 7.34375 16.7455C7.34375 18.975 9.15107 20.7822 11.3804 20.7822H22.4501Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3540_264748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.0001,
    height: 32,
    fill: "white",
    transform: "translate(0.386719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDriveOutlinedWhite);
export default __webpack_public_path__ + "static/media/icon_drive_outlined_white.e50f3fb11b5b683f0bec3d2a3b7dfd75.svg";
export { ForwardRef as ReactComponent };